export const SUSPENSAOFORNECEDORES_LIST = 'SUSPENSAOFORNECEDORES_LIST';
export const SUSPENSAOFORNECEDORES_LIST_START =
  'SUSPENSAOFORNECEDORES_LIST_START';
export const SUSPENSAOFORNECEDORES_LIST_SUCCESS =
  'SUSPENSAOFORNECEDORES_LIST_SUCCESS';
export const SUSPENSAOFORNECEDORES_LIST_ERROR =
  'SUSPENSAOFORNECEDORES_LIST_ERROR';
